import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ApisService } from "../../services/apis.service";
import * as moment from "moment";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: 'app-jockey-room-leave',
  templateUrl: './jockey-room-leave.component.html',
  styleUrls: [
    './jockey-room-leave.component.scss'
  ]
})
export class JockeyRoomLeaveComponent implements OnInit {
  @Input() race;
  public saving: boolean;
  public userId: number;
  public leaveRoomTime: {
    hour: number,
    minute: number,
    second: number
  };

  public constructor(
    public activeModal: NgbActiveModal,
    private apiService: ApisService,
    private notification: ToastrService
  ) {}

  public ngOnInit(): void {
    const now = moment();
    this.leaveRoomTime = {
      hour: now.hour(),
      minute: now.minute(),
      second: now.second()
    };
    this.apiService.observableLoggedIn.subscribe(data => {
      this.userId = data.user_id;
    });
  }

  public getLeaveWeighRoomTime(): string {
    return this.race.leaveWeighRoom !== null ? this.race.leaveWeighRoom : '-';
  }

  protected confirm(): void {
    this.saving = true;
    const leaveWeighRoom: string = `${this.leaveRoomTime.hour}:${this.leaveRoomTime.minute}:${this.leaveRoomTime.second}`;
    const payload: {} = {
      'leaveWeighRoom': leaveWeighRoom,
      'updatedBy': this.userId
    }

    this.apiService.updateJockeyRoomLeave(this.race.yearOfRace, this.race.raceId, this.race.divisionSequence, payload)
      .subscribe(
        res => {
          this.activeModal.close(leaveWeighRoom);
          this.notification.success('Jockey leaving time has been saved.', 'Last jockey leaves weighing room');
        },
        err => {
          console.error('[ DEBUG ] Error updating Race', err);
          this.notification.error(
            "Couldn't save jockey leaving time. Check your connection and Try again.",
            'Last jockey leaves weighing room'
          );
          this.saving = false;
        }
      );
  }

  protected cancel(action: string): void {
    this.activeModal.dismiss(action);
  }
}
